module.exports = __webpack_public_path__ + "img/imap.b4aa18b5.svg";